import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  output,
  signal,
  untracked,
} from '@angular/core';
import { MultiSelectCalendarComponent } from '../../../../../shared/components/calendar/multi-select-calendar/multi-select-calendar.component';
import { DatesService } from '../../services/dates.service';
import { weekdaysDateFilter } from '../../helpers/dates-filter';
import { Subject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { createActionState } from '@at/shared';
import { DatesApi } from '../../api';
import { FormControl, FormGroup } from '@angular/forms';
import { datesFromRange } from '../../helpers';

@Component({
  selector: 'at-availability-picker',
  standalone: true,
  imports: [MultiSelectCalendarComponent],
  /*   providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: MultiDayRangeSelectionStrategy,
    },
  ], */
  templateUrl: './availability-picker.component.html',
  styleUrl: './availability-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvailabilityPickerComponent {
  #datesService = inject(DatesService);
  #datesApi = inject(DatesApi);

  protected readonly datesForm = new FormGroup({
    availability: new FormControl<Date[]>([]),
  });
  protected save = new Subject<void>();
  protected readonly state = toSignal(
    createActionState({
      trigger: this.save,
      apiCall: () => this.#datesApi.postAvailability(this.selectedDates()),
      onSucceed: () => {
        this.datesForm.reset();
        this.#datesService.updateDatesSummary();
        this.availabilityChange.emit();
      },
    }),
  );

  protected readonly datesState = this.#datesService.datesSummary;

  protected readonly startDate = computed(() => {
    const startDate = this.datesState()?.data?.rangeCriteria?.start;
    if (!startDate) return new Date();

    return startDate;
  });
  protected readonly endDate = computed(() => {
    const endDate = this.datesState()?.data?.rangeCriteria?.end;
    if (!endDate) return new Date();

    return endDate;
  });
  protected readonly dateFilter = computed(() =>
    weekdaysDateFilter(this.datesState()?.data?.rangeCriteria),
  );
  protected selectedDates = signal<Date[]>([]);

  constructor() {
    effect(() => {
      const availability = this.datesState()?.data?.availabilityResponse?.availability;
      if (!availability) return;

      untracked(() => this.selectedDates.set(availability));
    });
  }

  protected selectAll() {
    const state = this.datesState();

    if (!state?.data?.rangeCriteria) return;

    this.selectedDates.set(datesFromRange(state.data.rangeCriteria));
  }

  protected clearAll() {
    this.selectedDates.set([]);
  }

  public availabilityChange = output();
}
